<div class="alert alert-info">
  <i class="fa fa-spin fa-spinner mr-1"></i>
  {{ text }}
</div>